import intl from 'react-intl-universal';
import CircleIcon from '@mui/icons-material/Circle';
import PropTypes from 'prop-types';
import { ONLINE_STATUS } from './components/constants';

export const userNameColumn = () => ({
  accessorKey: 'username',
  header: intl.get('friends_label_column_user_nickname'),
  enableColumnFilter: true,
  filterVariant: 'textField',
  filterFn: 'fuzzy',
  enableSorting: true,
});

export const userIDColumn = () => ({
  accessorKey: 'userID',
  header: intl.get('friends_label_column_user_id'),
  enableColumnFilter: true,
  filterVariant: 'textField',
  filterFn: 'fuzzy',
  enableSorting: true,
});

const OnlineStatusCell = ({ renderedCellValue }) => {
  return (
    <div>
      <CircleIcon
        sx={{
          color: renderedCellValue === ONLINE_STATUS.ONLINE ? 'green' : 'red',
        }}
      />
    </div>
  );
};

OnlineStatusCell.propTypes = {
  renderedCellValue: PropTypes.string,
};

export const onlineStatusColumn = () => ({
  accessorKey: 'onlineStatus',
  header: intl.get('friends_label_column_online_status'),
  enableColumnFilter: true,
  filterVariant: 'textField',
  filterFn: 'fuzzy',
  enableSorting: true,
  Cell: OnlineStatusCell,
  size: 30,
});

export const messageColumn = () => ({
  accessorKey: 'message',
  header: intl.get('friends_label_column_message'),
  enableColumnFilter: true,
  filterVariant: 'textField',
  filterFn: 'fuzzy',
  enableSorting: true,
});
